// Строка, а не AppDistribution: модуль читает и сборщик справки в node, а common.types тянет UI-кит
const SKAILER_DISTRIBUTION = "skailer";

/** Имя помощника; SK.AI (appAIName) остаётся названием технологии. */
export const getAppAssistantName = (distribution: string | undefined, appAIName: string) =>
  distribution === SKAILER_DISTRIBUTION ? "Skai" : appAIName;
